/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_State_ExpiredInputs */



/**
* | output |
* | --- |
* | "OAuth session expired. Please try again." |
*
* @param {Login_Error_State_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_state_expired = /** @type {((inputs?: Login_Error_State_ExpiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_State_ExpiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Session OAuth expirée. Veuillez réessayer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sesión OAuth expirada. Por favor, intente de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sessão OAuth expirada. Por favor, tente novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sessione OAuth scaduta. Riprova.")
	return /** @type {LocalizedString} */ ("OAuth session expired. Please try again.")
});